import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Dedicated release gate for the speaker UI on the V2 transcript: settings
 * gear, click a speaker label to re-attribute the turn (popover with Apply
 * to all instances / Other rename / Link patient), and patient-name display
 * rules.
 *
 * Whether the gear is offered for a given session is additionally decided
 * from that session's diarisation availability. Hidden when off.
 *
 * Provisioned in the infra repo `shared_infra/flags`. Lives in this standalone
 * `.ts` module (not the `index.ts` barrel) so it does not add a
 * `react-refresh/only-export-components` warning. Import via
 * `@/features/flags`, which re-exports it.
 */
export const DIARISATION_UI_FLAG_KEY = 'release-scribe-diarisation-ui';

export const DIARISATION_UI_FLAG_DEFAULT = false;

export const useIsDiarisationUiEnabled = (): boolean =>
  useBooleanFlagValue(DIARISATION_UI_FLAG_KEY, DIARISATION_UI_FLAG_DEFAULT);
